import { collectionApi } from './collection.api';

export const collectionActions = {
  async getCollections({ commit }, payload) {
    try {
      commit('GET_COLLECTIONS_LOADING');
      const response = await collectionApi.getCollections(payload);
      commit('GET_COLLECTIONS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_COLLECTIONS_ERROR', error.response);
    }
  },
  async addCollection({ commit }, body) {
    try {
      commit('ADD_COLLECTION_LOADING');

      await collectionApi.addCollection(body);

      commit('ADD_COLLECTION_SUCCESS');
    } catch (error) {
      commit('ADD_COLLECTION_ERROR', error.response);
    }
  },
  async updateCollection({ commit }, { id, body }) {
    try {
      commit('UPDATE_COLLECTION_LOADING');

      const response = await collectionApi.updateCollection(id, body);

      commit('UPDATE_COLLECTION_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_COLLECTION_ERROR', error.response);
    }
  },
  async getCollection({ commit }, id) {
    try {
      commit('GET_COLLECTION_LOADING');

      const response = await collectionApi.getCollection(id);

      commit('GET_COLLECTION_SUCCESS', response.data);
    } catch (error) {
      commit('GET_COLLECTION_ERROR', error.response);
    }
  },
  async deleteCollection({ commit }, id) {
    try {
      commit('DELETE_COLLECTION_LOADING');

      const response = await collectionApi.deleteCollection(id);

      commit('DELETE_COLLECTION_SUCCESS', response.data);
    } catch (error) {
      commit('DELETE_COLLECTION_ERROR', error.response);
    }
  },
  async updateSequence({ commit }, body) {
    try {
      commit('UPDATE_SEQUENCE_LOADING');

      await collectionApi.updateSequence(body);

      commit('UPDATE_SEQUENCE_SUCCESS');
    } catch (error) {
      commit('UPDATE_SEQUENCE_ERROR', error.response);
    }
  },
};
